import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { Select } from 'components/project/ClerkScreen';
import {
  getStoredAuctionIdByPath,
  getStoredAuctionLaneIdByPath,
} from 'shared/utils/localStorage';

import {
  ItemSearch,
  ItemListContainer,
  SectionTitle,
  AuctionAndLaneContainer,
} from './Styles';

const Settings = observer(({
  auctionList,
  currentAuctionId,
  handleAuctionChange,
  handleLaneChange,
}) => {
  const {
    UIStore: { handleJoinAuction },
    AuctionStore: { laneList },
  } = useStores();

  let laneList2 = laneList;
  if (
    getStoredAuctionLaneIdByPath() !== ''
    && laneList2
    && laneList2.length === 0
  ) {
    handleJoinAuction(getStoredAuctionIdByPath());
    laneList2 = laneList;
  }

  return (
    <ItemSearch>
      <>
        <SectionTitle>Settings</SectionTitle>
        <ItemListContainer>
          <AuctionAndLaneContainer>
            {auctionList && auctionList.length > 0 && (
              <Select
                valueProp="auctionID"
                textProp="auction"
                currentValue={currentAuctionId}
                data={auctionList}
                noneSelectedText="-- Choose Auction --"
                onChange={handleAuctionChange}
              />
            )}
            {getStoredAuctionLaneIdByPath() !== '' && (
              <Select
                valueProp="laneID"
                textProp="lane"
                currentValue={getStoredAuctionLaneIdByPath()}
                data={laneList2}
                noneSelectedText="-- Choose Lane --"
                onChange={handleLaneChange}
              />
            )}
          </AuctionAndLaneContainer>
        </ItemListContainer>
      </>
    </ItemSearch>
  );
});

export default Settings;
